import ArrayField from './component';

export default ArrayField;
